module.exports = __webpack_public_path__ + "img/interSel.aa96a654.svg";